module.exports = __webpack_public_path__ + "static/media/MATH135.e81495c3.PNG";